__turbopack_context__.v({
  "autoSendSuccess": "download-app-module-scss-module__OzkyEq__autoSendSuccess",
  "center": "download-app-module-scss-module__OzkyEq__center",
  "control": "download-app-module-scss-module__OzkyEq__control",
  "download-app": "download-app-module-scss-module__OzkyEq__download-app",
  "error": "download-app-module-scss-module__OzkyEq__error",
  "field": "download-app-module-scss-module__OzkyEq__field",
  "field-small": "download-app-module-scss-module__OzkyEq__field-small",
  "form": "download-app-module-scss-module__OzkyEq__form",
  "left": "download-app-module-scss-module__OzkyEq__left",
  "medium": "download-app-module-scss-module__OzkyEq__medium",
  "placement--header": "download-app-module-scss-module__OzkyEq__placement--header",
  "small": "download-app-module-scss-module__OzkyEq__small",
  "submit": "download-app-module-scss-module__OzkyEq__submit",
  "success": "download-app-module-scss-module__OzkyEq__success",
  "why": "download-app-module-scss-module__OzkyEq__why",
});
